import { Container } from "./styles";
import externalLink from "../../assets/external-link.svg"
import { motion } from "framer-motion"

export function Project() {
  const projects = [
    {
      title: "Minni.uz | Havolani qisqartiramiz",
      description: "This site is designed to shorten links and generate a QR code for a link.",
      achieved: "7.2k+ URLs shortened and managed securely.",
      tech: ["NodeJs", "Javascript", "React", "MongoDB"],
      link: "https://minni.uz/",
    },
    {
      title: "Minniuz - telegram bot",
      description: "This bot is minni.uz's telegram bot and is intended for some customers who don't want to visit sites.",
      achieved: "Grew to 80+ active users providing quick link access.",
      tech: ["NodeJs", "Javascript", "MongoDB"],
      link: "https://t.me/minniuzbot",
    },
    {
      title: "Uzbekistan Taxi - Raqamli taxi xizmati",
      description: "The Uzbekistan telegram bot is for passengers and drivers traveling between regions of Uzbekistan, passengers can send requests to the driver through the telegram bot.",
      achieved: "Successfully onboarded 360+ users, digitizing regional travel.",
      tech: ["NodeJs", "Javascript", "Redis", "MongoDB"],
      link: "https://t.me/uzbekistantaxirobot",
    }
  ];

  return (
    <Container id="project">
      <h2>My Projects</h2>
      <div className="projects">
        {projects.map((project, index) => (
          <motion.div 
            key={index}
            className="project"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            viewport={{ once: true }}
          >
            <header>
              <div className="api-route">
                <span className="method">GET</span> /api/projects/{index + 1}
              </div>
              <div className="project-links">
                <a href={project.link} target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="code-body">
              <div className="line">
                <span className="bracket">{"{"}</span>
              </div>
              <div className="line" style={{ paddingLeft: '2rem' }}>
                <span className="key">"title"</span>: <span className="value">"{project.title}"</span>,
              </div>
              <div className="line" style={{ paddingLeft: '2rem' }}>
                <span className="key">"description"</span>: <span className="value">"{project.description}"</span>,
              </div>
              <div className="line" style={{ paddingLeft: '2rem' }}>
                <span className="key">"achieved"</span>: <span className="value">"{project.achieved}"</span>,
              </div>
              <div className="line" style={{ paddingLeft: '2rem' }}>
                <span className="key">"status"</span>: <span className="value">"deployed"</span>,
              </div>
              <div className="line">
                <span className="bracket">{"}"}</span>
              </div>
            </div>
            <footer>
              <ul className="tech-list">
                {project.tech.map(t => <li key={t}>{t}</li>)}
              </ul>
            </footer>
          </motion.div>
        ))}
      </div>
    </Container>
  );
}